/**
 * Helpers for workflow builder undo/redo snapshots.
 */

export const WORKFLOW_HISTORY_MAX = 50;

export function cloneWorkflowSnapshot(workflow) {
  if (!workflow) return workflow;
  return JSON.parse(JSON.stringify(workflow));
}

export function getUndoRedoShortcutLabels() {
  const isMac = typeof navigator !== 'undefined'
    && /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent);
  return {
    undo: isMac ? 'Cmd+Z' : 'Ctrl+Z',
    redo: isMac ? 'Cmd+Y' : 'Ctrl+Y',
    redoAlt: isMac ? 'Cmd+Shift+Z' : 'Ctrl+Shift+Z',
  };
}
